import {
  getFetchData,
  deleteSupplierById,
} from "../../services/supplierService";
import swal from "sweetalert";
import { toast } from "react-toastify";
import Loading from "../../components/loading";
import { useNavigate } from "react-router-dom";
import { withTranslation } from "react-i18next";
import React, { useEffect, useState } from "react";
import AddButton from "../../components/AddButton";
import { useSelector } from "react-redux/es/exports";
import EditButton from "../../components/EditButton";
import DeleteButton from "../../components/DeleteButton";
import TempDataTable from "../../components/TemDataTable";

const headerTable = [
  {
    name: "ID",
  },
  {
    name: "name",
  },
  {
    name: "countryPage.currency",
  },
  {
    name: "countryPage.is_active",
  },
  {
    name: "countryPage.is_default",
  },
  <span className="sr-only">Actions</span>,
];

const bodyTable = ["id", "name", "currencyName", "isActive", "isDefault", "actions"];

function Countrys({ t }) {
  const navigate = useNavigate();
  const [country, setCountry] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const { token } = useSelector((state) => state.user);

  const fetchCountry = async () => {
    setIsLoading(true);
    try {
      const response = await getFetchData(
        `${process.env.REACT_APP_HOST_BASE_URL}/v1/country/list`,
        token
      );

      if (response?.success) {
        const data = response?.data.map((item) => {
          return {
            id: item.id,
            name: item.name,
            currencyName: item.currencyName || item.currency?.name || "—",
            isActive: (
              <div className="flex items-center h-5">
                <input
                  disabled
                  type="checkbox"
                  checked={item.isActive}
                  className="w-4 h-4 text-gray-500 border-gray-600 rounded focus:ring-gray-300 ml-5"
                />
              </div>
            ),
            isDefault: (
              <div className="flex items-center h-5">
                <input
                  disabled
                  type="checkbox"
                  checked={item.isDefault}
                  className="w-4 h-4 text-gray-500 border-gray-600 rounded focus:ring-gray-300 ml-5"
                />
              </div>
            ),
            actions: (
              <div className="flex justify-end">
                <EditButton
                  onclick={() => {
                    navigate(`/country/update/${item.id}`);
                  }}
                />
                <DeleteButton onclick={() => onDeleteItem(item.id)} />
              </div>
            ),
          };
        });
        setCountry(data);
      }
    } catch (error) {
      console.error("Fetch country error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const onDeleteItem = async (id) => {
    const responseReceived = await swal({
      title: t(`action.delete_item.title`),
      text: t(`action.delete_item.text`),
      icon: "warning",
      buttons: {
        cancel: true,
        confirm: true,
      },
    });
    if (responseReceived) {
      setIsLoading(true);
      const response = await deleteSupplierById(
        `${process.env.REACT_APP_HOST_BASE_URL}/v1/country/${id}`,
        token
      );
      if (response.success) {
        fetchCountry();
        toast.success(t("action.delete_success"), {
          position: "bottom-right",
          autoClose: 3000,
          closeOnClick: true,
          className: "add-success",
        });
      } else {
        setIsLoading(false);
        navigate("/error", {
          state: {
            status: response.status,
            message: response.message ? response.message : null,
          },
        });
      }
    } else {
      return;
    }
  };

  useEffect(() => {
    fetchCountry();
  }, []);

  const sortFunction = (value) => {
    console.log("sortFunction", value);
  };

  return (
    <>
      {isLoading ? (
        <Loading />
      ) : (
        <div className="px-4 py-4 sm:px-6 lg:px-8">
          <div className="mb-2 sm:flex sm:items-center">
            <div className="sm:flex-auto">
              <h1 className="text-xl font-semibold text-gray-900">
                {t("country")}
              </h1>
            </div>
            <AddButton title={t("countryPage.add_country")} url={"add"} />
          </div>
          <div>
            <TempDataTable
              data={country}
              headerTable={headerTable}
              bodyContent={bodyTable}
              sortFunction={sortFunction}
            />
          </div>
        </div>
      )}
    </>
  );
}

export default withTranslation()(Countrys);
